import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { Button } from '@mendeley-internal/react-ui';
import { createUrl, getQueryObject, getQueryString } from '../../utils/url';
import { signInToAddToLibrary, signInToViewPdf } from '../../actions/session';

const StyledButton = styled(Button)`
  &:hover {
    text-decoration: none;
  }
`;

function SignIn(props) {
  const {
    doc: {
      id,
    },
    baseURL,
    isEntitled,
    location,
  } = props;

  const newQuery = {
    ...getQueryObject(location.search),
  };

  if (!isEntitled) {
    newQuery.save = id;
  }

  const routeTo = {
    ...location,
    search: `?${getQueryString(newQuery)}`
  };

  const loginPath = `/sign/in/?routeTo=${encodeURIComponent(createUrl(baseURL, routeTo))}`;

  if (isEntitled) {
    return (
      <StyledButton
        size="medium"
        iconName="login"
        iconBefore
        data-name="view-pdf"
        href={loginPath}
        onClick={() => props.signInToViewPdf(id)}
      >
        Sign in to view PDF
      </StyledButton>
    );
  }

  return (
    <StyledButton
      size="medium"
      iconName="login"
      iconBefore
      data-name="save-reference"
      href={loginPath}
      onClick={() => props.signInToAddToLibrary(id)}
    >
      Sign in to add to library
    </StyledButton>
  );
}

const mapStateToProps = state => ({
  baseURL: state.location.baseURL,
});

const mapDispatchToProps = {
  signInToAddToLibrary,
  signInToViewPdf,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SignIn));



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationActions/SignIn.js